export const faqContacts = {
  emergencyPhone: "+1 (800) 578-0256",
  supportUsEmail: "support@staywithoasis.com",
  supportIntlEmail: "gsintl@staywithoasis.com",
  newClientEmail: "hello@staywithoasis.com",
};

const faqData = [
  {
    id: "OAS-001",
    category: "About Oasis",
    question: `Who is Oasis?`,
    answer: `Oasis is a global temporary accommodation provider. We source and manage furnished housing for corporate travelers, relocating employees, project teams, interns, families, and other guests who need a comfortable home for a temporary stay. Oasis combines global coverage, local market expertise, quality controls, technology, and human support throughout the stay.`,
  },
  {
    id: "OAS-002",
    category: "About Oasis",
    question: `Where does Oasis operate?`,
    answer: `Oasis supports temporary accommodation needs globally. Coverage and available accommodation vary by destination, dates, length of stay, and guest requirements. Share the location and dates, and the Oasis team can confirm what is available.`,
  },
  {
    id: "OAS-003",
    category: "About Oasis",
    question: `Who does Oasis serve?`,
    answer: `Oasis supports corporate mobility programs, temporary assignments, relocations, project teams, business travelers, families, and other temporary housing needs. Booking eligibility and payment arrangements may depend on the relevant company program or reservation.`,
  },
  {
    id: "OAS-004",
    category: "Why Oasis",
    question: `What makes Oasis different?`,
    answer: `Oasis combines global reach with a high-touch managed service. Key strengths include one coordinated point of contact, multiple sourcing channels, vetted accommodation partners, pre-arrival quality controls, 24/7 support from Oasis employees, and technology that supports visibility and reporting. The best fit depends on your location, budget, timing, and service needs.`,
  },
  {
    id: "OAS-005",
    category: "Why Oasis",
    question: `Why use Oasis instead of another provider?`,
    answer: `Different providers use different service and inventory models. Oasis focuses on global coverage, human-led service, a single point of accountability, quality-controlled accommodation options, 24/7 support from Oasis employees, and program visibility through Metis. Tell the Oasis team what matters most—coverage, service, budget, reporting, or guest experience—and they can explain how Oasis would approach your needs.`,
  },
  {
    id: "OAS-006",
    category: "Housing request",
    question: `How do I submit a housing request?`,
    answer: `Submit the destination, check-in and check-out dates, number of occupants, bedroom needs, budget, and any important requirements such as pets, accessibility, commute, parking, or preferred neighborhoods. If you are a new client or new lead, email hello@staywithoasis.com and an Oasis team member will help with your request.`,
  },
  {
    id: "OAS-007",
    category: "Housing request",
    question: `How long will it take to receive a response?`,
    answer: `Oasis aims to acknowledge housing requests within 30 minutes during business hours. Vetted options are typically provided within 4 hours in standard markets. Complex or remote-market requests may take up to 24 hours, and the team will provide updates if more time is needed.`,
  },
  {
    id: "OAS-008",
    category: "Housing request",
    question: `Can Oasis help with an urgent or same-day request?`,
    answer: `Yes. Oasis can prioritize urgent and same-day requests in many major markets. Availability depends on the destination and timing. Share the location, arrival time, length of stay, number of guests, budget, and a contact number so the team can act quickly.`,
  },
  {
    id: "OAS-009",
    category: "Housing request",
    question: `How many options will I receive?`,
    answer: `Oasis normally aims to present at least three suitable options when market availability allows. In constrained, urgent, or remote markets, fewer options may be available. The team will explain any market limitations and continue sourcing where appropriate.`,
  },
  {
    id: "OAS-010",
    category: "Housing request",
    question: `Can Oasis source housing in remote locations?`,
    answer: `Yes. Oasis uses its global supplier network and on-demand sourcing for less common or remote locations. These requests can require additional time for sourcing, vetting, and compliance checks, so options may take up to 24 hours or longer if the market is exceptionally limited. The team will keep you updated.`,
  },
  {
    id: "OAS-011",
    category: "Availability and booking",
    question: `Does a quote guarantee availability?`,
    answer: `A quoted option reflects availability validated when the option was prepared, but it is not secured until Oasis reconfirms availability and the required booking documentation is completed. Availability can change quickly. Tell the team your preferred option as soon as possible so they can request a hold or proceed with confirmation.`,
  },
  {
    id: "OAS-012",
    category: "Availability and booking",
    question: `Can Oasis place a hold on an apartment?`,
    answer: `Oasis will request the longest available hold from the accommodation provider. A 24-hour hold cannot be guaranteed for every property because it depends on supplier approval, availability, and market conditions. Any hold expiry will be clearly communicated.`,
  },
  {
    id: "OAS-013",
    category: "Availability and booking",
    question: `How is a booking confirmed?`,
    answer: `After you select an option, Oasis reconfirms availability and final terms with the accommodation provider. The required reservation or lease documents are then issued for approval and electronic signature. The reservation is final only after the required confirmations and documentation are completed.`,
  },
  {
    id: "OAS-014",
    category: "Availability and booking",
    question: `How quickly is a selected option confirmed?`,
    answer: `Once an option is selected, Oasis typically aims to secure the booking confirmation within 24 hours and often on the same day. Timing depends on market conditions, supplier responsiveness, approvals, and completion of required documents.`,
  },
  {
    id: "OAS-015",
    category: "Availability and booking",
    question: `Can I book directly through the AI assistant?`,
    answer: `The assistant can help you gather your requirements, explain the process, and direct you to the Oasis team. It cannot confirm a booking: a live Oasis housing specialist must reconfirm availability, final terms, and the required booking documents before a reservation is confirmed.`,
  },
  {
    id: "OAS-016",
    category: "Accommodation",
    question: `What types of accommodation does Oasis provide?`,
    answer: `Oasis sources furnished apartments, serviced apartments, extended-stay accommodation, and other temporary housing solutions. Options may come from vetted Alliance Partners, directly managed Oasis Private Collection inventory, or an on-demand solution created for a specific need. The available type depends on the market, dates, budget, and guest requirements.`,
  },
  {
    id: "OAS-017",
    category: "Accommodation",
    question: `What is Oasis Private Collection?`,
    answer: `Oasis Private Collection, or OPC, is Oasis's selectively managed inventory of furnished accommodations. It complements the wider global supplier network and can provide additional consistency and control in participating markets. Availability varies by location and dates.`,
  },
  {
    id: "OAS-018",
    category: "Accommodation",
    question: `What is on-demand housing?`,
    answer: `For certain needs, Oasis can source a suitable residential unit and arrange furniture, housewares, utilities, and other setup services for the stay. This can be useful in remote or supply-constrained markets. Feasibility and lead time depend on local leasing rules, availability, and the length of stay.`,
  },
  {
    id: "OAS-019",
    category: "Accommodation",
    question: `What is normally included in an Oasis apartment?`,
    answer: `Options are typically fully furnished and include essential housewares, utilities, and Wi-Fi. Exact inclusions vary by property and market. Housekeeping, parking, television services, utility caps, and other extras may be included or charged separately, so always review the specific quotation and reservation terms.`,
  },
  {
    id: "OAS-020",
    category: "Accommodation",
    question: `Is housekeeping included?`,
    answer: `Housekeeping varies by property and market. It is commonly included in many international serviced-apartment stays, often weekly, while in the United States and Canada it may be optional or separately charged. The exact schedule and cost will be shown in the property offer or reservation terms.`,
  },
  {
    id: "OAS-021",
    category: "Accommodation",
    question: `Is parking included?`,
    answer: `Parking is property-specific. It may be included, available for an additional charge, subject to vehicle restrictions, or unavailable. Share the property or booking reference and vehicle details so the Oasis team can confirm the exact arrangement.`,
  },
  {
    id: "OAS-022",
    category: "Accommodation",
    question: `Are pets allowed?`,
    answer: `Many properties accept pets, but policies are specific to each building and supplier. Fees, deposits, breed or size restrictions, and limits on the number of pets may apply. Mention every pet at the request stage so Oasis can confirm suitable options and all applicable terms before booking.`,
  },
  {
    id: "OAS-023",
    category: "Accommodation",
    question: `Can Oasis provide accessible accommodation?`,
    answer: `Yes. Oasis can source accommodations that meet ADA or relevant local accessibility requirements, subject to market availability. Accessibility needs must be provided at the request stage and verified for the specific property before booking.`,
  },
  {
    id: "OAS-024",
    category: "Accommodation",
    question: `Can Oasis accommodate families or groups?`,
    answer: `Yes. Oasis can source studios and multi-bedroom accommodations for individuals, couples, families, and groups. Availability of larger homes varies significantly by market, so provide the number of occupants, bedroom needs, ages of children where relevant, and any special requirements.`,
  },
  {
    id: "OAS-025",
    category: "Quality and safety",
    question: `How does Oasis check property quality?`,
    answer: `Oasis uses structured supplier qualification, property vetting, and pre-arrival quality control. Units are checked against a detailed 225-point inspection covering areas such as cleanliness, condition, furnishings, housewares, utilities, internet, appliances, access, and safety features. Any identified issues are escalated for correction before arrival whenever possible.`,
  },
  {
    id: "OAS-026",
    category: "Quality and safety",
    question: `When is the apartment inspected?`,
    answer: `Oasis normally completes or validates the pre-move-in inspection within the 24–48 hours before arrival. For urgent or same-day bookings, the inspection may be completed within 24 hours after check-in, with immediate follow-up on any issues identified.`,
  },
  {
    id: "OAS-027",
    category: "Quality and safety",
    question: `How does Oasis assess safety and security?`,
    answer: `Oasis reviews property, building, neighborhood, access, and life-safety information during supplier onboarding, property vetting, and inspection. The process considers local regulations, building access, locks, lighting, fire and life-safety measures, emergency access, and client-specific requirements. No provider can guarantee that a location is risk-free; for a specific property, Oasis can confirm the information available and apply the relevant program requirements.`,
  },
  {
    id: "OAS-028",
    category: "Quality and safety",
    question: `Does Oasis comply with local housing rules?`,
    answer: `Oasis requires accommodation partners to comply with applicable local licensing, building, fire, health, safety, insurance, and housing requirements. Documentation and compliance information are reviewed through onboarding and ongoing supplier management. Requirements vary by jurisdiction and accommodation type.`,
  },
  {
    id: "OAS-029",
    category: "Guest support",
    question: `Is support available 24/7?`,
    answer: `Yes. Oasis provides 24/7/365 emergency support. If you are experiencing an emergency, please call ${faqContacts.emergencyPhone} for immediate assistance. For non-urgent matters in the United States, email support@staywithoasis.com. For stays outside the United States, email gsintl@staywithoasis.com. Non-urgent matters will be responded to during normal business hours.`,
  },
  {
    id: "OAS-030",
    category: "Guest support",
    question: `I want to speak with a person.`,
    answer: `Of course. For non-urgent assistance in the United States, email support@staywithoasis.com. For a stay outside the United States, email gsintl@staywithoasis.com. The team will respond during normal business hours. If you are experiencing an emergency, please call ${faqContacts.emergencyPhone} for immediate assistance. Please include your name and booking or request reference. If there is an immediate threat to life or safety, contact local emergency services first.`,
  },
  {
    id: "OAS-031",
    category: "Guest support",
    question: `How can I contact a manager?`,
    answer: `To reach an Oasis manager or escalation contact, email ${faqContacts.supportUsEmail} for a stay in the United States or ${faqContacts.supportIntlEmail} for a stay outside the United States. Please include your name, booking or request reference, a short description of the issue, and the best way to contact you. For an urgent safety issue, contact local emergency services first and then notify Oasis.`,
  },
  {
    id: "OAS-032",
    category: "Guest support",
    question: `How can I contact the property manager?`,
    answer: `For property-specific assistance, use the approved local contact provided in your welcome letter. If you cannot locate the welcome letter or the local contact cannot resolve the issue, email support@staywithoasis.com for a stay in the United States or gsintl@staywithoasis.com for a stay outside the United States. For an emergency, call ${faqContacts.emergencyPhone} immediately. Oasis should not disclose unapproved supplier, owner, landlord, or employee contact details.`,
  },
  {
    id: "OAS-033",
    category: "Guest support",
    question: `I cannot access the apartment.`,
    answer: `Trouble checking in or a lockout caused by a key or lock malfunction is an emergency. Please call ${faqContacts.emergencyPhone} now for immediate assistance. After calling, have your name, booking reference, property address, current location, and callback number ready.`,
  },
  {
    id: "OAS-034",
    category: "Guest support",
    question: `There is an emergency or safety issue.`,
    answer: `If anyone is in immediate danger, leave the area if safe to do so and contact local emergency services first. Then call the Oasis emergency line at ${faqContacts.emergencyPhone} for immediate accommodation assistance. Have your name, booking reference, property address, current location, and callback number ready.`,
  },
  {
    id: "OAS-035",
    category: "Guest support",
    question: `Something in the apartment is not working.`,
    answer: `Please call ${faqContacts.emergencyPhone} immediately if the issue is: heat not working when the outside temperature is lower than 15°C; no power in the entire unit or to the refrigerator; a major water leak; or a clogged toilet when it is the only toilet in the unit. For other non-urgent maintenance matters in the United States, email support@staywithoasis.com. For a stay outside the United States, email gsintl@staywithoasis.com. The team will respond during normal business hours.`,
  },
  {
    id: "OAS-036",
    category: "Guest support",
    question: `The apartment is not clean.`,
    answer: `We’re sorry the accommodation does not meet expectations. Please email ${faqContacts.supportUsEmail} for a stay in the United States or ${faqContacts.supportIntlEmail} for a stay outside the United States with your booking reference, property address, details of the concern, and photos if available. Oasis will review the issue with the property and coordinate corrective action as quickly as possible.`,
  },
  {
    id: "OAS-037",
    category: "Guest journey",
    question: `What information will I receive before arrival?`,
    answer: `Before arrival, guests receive welcome information with accommodation details, access instructions, key contacts, and essential stay information. Arrival details are typically resent approximately 24 hours before check-in. If you have not received them, provide your booking reference and contact details so the team can help.`,
  },
  {
    id: "OAS-038",
    category: "Guest journey",
    question: `Does Oasis check in with guests during the stay?`,
    answer: `Yes. Oasis uses a structured five-point communication program covering booking and welcome, pre-arrival, post-arrival, mid-stay, and pre-departure or extension communication. These touchpoints help identify concerns early and manage extensions or departure arrangements proactively.`,
  },
  {
    id: "OAS-039",
    category: "Changes and extensions",
    question: `How do I extend my stay?`,
    answer: `Contact Oasis as early as possible with your booking reference and requested new departure date. Extensions depend on property availability and may involve revised rates or terms. The team will confirm availability and obtain approval where required before the extension is final.`,
  },
  {
    id: "OAS-040",
    category: "Changes and extensions",
    question: `Can I shorten or cancel my stay?`,
    answer: `Cancellation and early-departure terms vary by property, market, and reservation. Review the terms in your quotation or reservation confirmation and contact Oasis as soon as possible. Oasis will work with the accommodation provider to seek the most flexible outcome available, but fees or notice requirements may apply.`,
  },
  {
    id: "OAS-041",
    category: "Changes and extensions",
    question: `Can cancellation fees be waived?`,
    answer: `Oasis will ask the accommodation provider to waive or reduce fees where possible, including for force majeure or employer-initiated changes. The outcome depends on the property's terms, local market practices, timing, and supporting circumstances, so a waiver cannot be guaranteed.`,
  },
  {
    id: "OAS-042",
    category: "Rates and payments",
    question: `What is included in the rate?`,
    answer: `Rates are structured to be as inclusive as possible and typically cover rent, furniture, housewares, utilities, Wi-Fi, tenancy or reservation management, and 24/7 support. Housekeeping, parking, local taxes, utility caps, pet fees, and other property-specific charges may be separate. The quotation will show the applicable inclusions and charges before booking.`,
  },
  {
    id: "OAS-043",
    category: "Rates and payments",
    question: `How much does temporary housing cost?`,
    answer: `Pricing depends on the destination, dates, length of stay, apartment size, season, availability, and required amenities. Share those details and Oasis can prepare current options. Rates are not estimated or guaranteed without a live quotation.`,
  },
  {
    id: "OAS-044",
    category: "Rates and payments",
    question: `What payment methods are accepted?`,
    answer: `Payment arrangements depend on the booking, country, and corporate program. Oasis may support company billing, approved letters of responsibility, card payments, or other agreed methods. A housing specialist or accounting contact can confirm the requirements for your reservation.`,
  },
  {
    id: "OAS-045",
    category: "Rates and payments",
    question: `Can I get an invoice or billing help?`,
    answer: `Yes. Please provide the booking reference, invoice number if available, company name, and a brief description of what you need. The Oasis accounting or account team will review the request. Do not share full payment-card details in chat.`,
  },
  {
    id: "OAS-046",
    category: "Corporate programs",
    question: `Can Oasis manage a global housing program?`,
    answer: `Yes. Oasis supports global temporary accommodation programs through centralized governance, regional teams, local market knowledge, one coordinated service model, and coverage in more than 130 countries. Programs can include sourcing, booking, guest support, quality assurance, reporting, billing alignment, and continuous improvement.`,
  },
  {
    id: "OAS-047",
    category: "Corporate programs",
    question: `How long does implementation take?`,
    answer: `A typical corporate program implementation takes approximately three to four weeks, depending on scope, stakeholder availability, legal and security reviews, reporting needs, and integrations. Where appropriate, operational support may begin while technical or compliance work continues in parallel.`,
  },
  {
    id: "OAS-048",
    category: "Corporate programs",
    question: `Do clients get a dedicated account manager?`,
    answer: `Corporate programs are supported by an assigned account lead, backup coverage, and regional operational teams. This provides clear ownership while maintaining continuity across time zones, absences, and urgent situations. The exact team and escalation structure are agreed during implementation.`,
  },
  {
    id: "OAS-049",
    category: "Technology",
    question: `What is Metis?`,
    answer: `Metis is Oasis's proprietary accommodation management platform. It supports request intake, workflows, approvals, booking visibility, reporting, supplier and service oversight, and management of the accommodation lifecycle. Available features and access depend on the client's program configuration.`,
  },
  {
    id: "OAS-050",
    category: "Technology",
    question: `Can Metis recommend accommodation?`,
    answer: `Metis includes Best Match functionality that helps identify options aligned with program parameters, guest requirements, budget, location, quality, and other relevant criteria. Oasis specialists review recommendations before options are presented; technology supports the process but does not replace human judgment or confirmation.`,
  },
  {
    id: "OAS-051",
    category: "Technology",
    question: `What reporting is available?`,
    answer: `Depending on program configuration, Metis reporting can provide visibility into booking activity, spend, destinations, length of stay, supplier usage, extensions, service performance, sustainability, carbon reporting, predictive rate analysis, and market benchmarking. Reporting fields, cadence, access, and dashboards are agreed with each client.`,
  },
  {
    id: "OAS-052",
    category: "Technology",
    question: `Does Oasis have a guest app?`,
    answer: `The Oasis mobile app can provide guests with booking details, property information, arrival instructions, emergency contacts, local guidance, and support resources. Availability and access instructions depend on the booking and program. If you cannot access your information, provide your booking reference so the team can assist.`,
  },
  {
    id: "OAS-053",
    category: "Sustainability",
    question: `What does Oasis do about sustainability?`,
    answer: `Oasis incorporates sustainability into supplier engagement, accommodation sourcing, reporting, and program improvement. Initiatives include the Green Leaf Program, sustainability data and carbon reporting capabilities, EcoVadis participation, and tree-planting support. Specific reporting and program features depend on the client scope and available data.`,
  },
  {
    id: "OAS-054",
    category: "Privacy and security",
    question: `How does Oasis protect personal data?`,
    answer: `Oasis uses access controls, data-protection practices, employee security training, and contractual privacy and confidentiality requirements to protect client and guest information. Access is limited according to role and program needs. For detailed security, privacy, or compliance questions, contact Oasis at ${faqContacts.newClientEmail} and the question will be directed to the appropriate Oasis representative.`,
  },
  {
    id: "OAS-055",
    category: "Privacy and security",
    question: `What information should I not share in chat?`,
    answer: `Do not send full payment-card details, passwords, account credentials, passport or national ID numbers, medical records, or other highly sensitive personal information in chat. An Oasis team member can direct you to an approved secure method if documentation is required.`,
  },
  {
    id: "OAS-056",
    category: "Service issues",
    question: `How do I make a complaint?`,
    answer: `We’re sorry the experience has not met expectations. Please email ${faqContacts.supportUsEmail} for a stay in the United States or ${faqContacts.supportIntlEmail} for a stay outside the United States with your name, booking or request reference, a concise description of what happened, when it occurred, and the best contact method. The issue will be routed to the appropriate Oasis team for review and follow-up.`,
  },
  {
    id: "OAS-057",
    category: "Service issues",
    question: `Will Oasis relocate me if the property is unusable?`,
    answer: `If a serious issue makes the accommodation unsafe or unusable, Oasis will assess the situation urgently, coordinate with the property, and identify alternative accommodation when required. Any immediate danger should be reported first to local emergency services. Final arrangements depend on the facts, availability, and applicable booking terms.`,
  },
  {
    id: "OAS-058",
    category: "General",
    question: `Can you confirm a property's amenities or policy?`,
    answer: `Amenities and policies vary by property and can change. Provide the property, option, or booking reference, and the Oasis team can verify the current details. Amenities, fees, and policies are not inferred from a general description.`,
  },
  {
    id: "OAS-061",
    category: "Quality and safety",
    question: `What does the walkthrough inspection check?`,
    answer: `The walkthrough covers the condition, cleanliness, setup, and functionality of the accommodation. Checks include access devices, parking information, Wi-Fi, water, appliances, furniture, linens, bathrooms, heating and cooling, washer and dryer where provided, window coverings, and general safety and maintenance concerns. The exact checklist may vary by accommodation type and market.`,
  },
  {
    id: "OAS-062",
    category: "Quality and safety",
    question: `Does Oasis document the inspection with photos?`,
    answer: `The walkthrough process includes photo documentation of key rooms, furnishings, appliances, connectivity, access arrangements, and any cleanliness or damage concerns. This helps Oasis validate readiness, record the condition of the accommodation, and follow up on issues identified before arrival.`,
  },
  {
    id: "OAS-063",
    category: "Quality and safety",
    question: `Is the Wi-Fi tested before arrival?`,
    answer: `The walkthrough process includes checking the Wi-Fi connection and recording the network information available for the guest. This reduces avoidable arrival issues, but service interruptions can still occur. If the connection is not working during a stay, contact Oasis support for assistance.`,
  },
  {
    id: "OAS-064",
    category: "Quality and safety",
    question: `Are appliances and utilities tested?`,
    answer: `The walkthrough includes functional checks of applicable utilities and appliances, such as water, kitchen equipment, heating or cooling, television, and laundry equipment where provided. Any issue identified is reported for corrective action. Exact equipment varies by property.`,
  },
  {
    id: "OAS-065",
    category: "Technology",
    question: `Can Metis reports be customized and exported?`,
    answer: `For applicable client programs, Metis provides configurable reporting with filters and selectable data fields. Reports can be saved as templates and exported to Excel. Access, available fields, and self-service permissions depend on the client's program configuration.`,
  },
  {
    id: "OAS-066",
    category: "Technology",
    question: `Can Metis show who may be affected by an emergency?`,
    answer: `For authorized client users, Metis reporting can support arrival and departure views, tenant rosters, and booking-location reporting. This can help identify guests who may be affected by a local emergency or disruption. Access is permission-based and subject to applicable privacy and program rules.`,
  },
  {
    id: "OAS-067",
    category: "Technology",
    question: `Can Oasis provide indicative market rates?`,
    answer: `Oasis can provide indicative rate information using historical quote data and market benchmarking in Metis. Results can be filtered by factors such as location, unit size, and length of stay. Indicative rates are planning guidance only and do not guarantee current availability or a final booking rate.`,
  },
  {
    id: "OAS-068",
    category: "Accommodation",
    question: `Can Oasis source and book hotels?`,
    answer: `Yes. Oasis can source and manage hotel and extended-stay hotel options as part of a temporary accommodation program. The team can present the rate, taxes, inclusions, and cancellation terms and then manage the reservation and ongoing support. Availability and process depend on the market and program.`,
  },
  {
    id: "OAS-069",
    category: "Rates and payments",
    question: `Can options be shown in another currency?`,
    answer: `Oasis can support presentation and billing in multiple currencies, depending on the program and booking arrangement. Currency conversions, exchange-rate treatment, taxes, and payment requirements should be confirmed for the specific quotation or client program.`,
  },
  {
    id: "OAS-070",
    category: "Corporate programs",
    question: `Can Oasis help clients analyze cost savings?`,
    answer: `For applicable client programs, Oasis can use historical quotes, market benchmarks, budgets or not-to-exceed limits, and documented negotiated reductions to support cost-savings analysis. The agreed methodology, baseline, data scope, and reporting format are defined with each client so results remain transparent and consistent.`,
  },
  {
    id: "OAS-071",
    category: "Guest support",
    question: `How do I contact Oasis support?`,
    answer: `For property-specific assistance, use the approved local contact in your welcome letter. For non-urgent Oasis assistance in the United States, email support@staywithoasis.com. For a stay outside the United States, email gsintl@staywithoasis.com. The team will respond during normal business hours. If you are experiencing an emergency, call ${faqContacts.emergencyPhone} for immediate assistance. If there is an immediate threat to life or safety, contact local emergency services first.`,
  },
  {
    id: "OAS-072",
    category: "Guest support",
    question: `What counts as an accommodation emergency?`,
    answer: `Call ${faqContacts.emergencyPhone} immediately for: trouble checking in; a lockout caused by a key or lock malfunction; heat not working when the outside temperature is lower than 15°C; no power in the entire unit or to the refrigerator; a major water leak; or a clogged toilet when it is the only toilet in the unit. For non-urgent matters in the United States, email support@staywithoasis.com. For a stay outside the United States, email gsintl@staywithoasis.com. Non-urgent matters will be responded to during normal business hours. If there is an immediate threat to life or safety, contact local emergency services first.`,
  },
  {
    id: "OAS-073",
    category: "New enquiries",
    question: `How can a new client contact Oasis?`,
    answer: `If you are a new client or new lead, email hello@staywithoasis.com. Please include your name, company, destination or markets, anticipated dates, and a short description of your temporary accommodation needs so the appropriate Oasis team member can respond.`,
  },
  {
    id: "OAS-074",
    category: "About Oasis",
    question: `When was Oasis founded?`,
    answer: `Oasis was established in 2008 and provides temporary furnished accommodation and managed housing solutions globally.`,
  },
  {
    id: "OAS-075",
    category: "Housing request",
    question: `Did Oasis receive my request?`,
    answer: `Oasis aims to acknowledge housing requests within 30 minutes during normal business hours. If you have not received an acknowledgement, please provide your name, email address, destination, and approximate submission time so the Oasis team can check the request. Please, send your inquiry to info@staywithoasis.com.`,
  },
  {
    id: "OAS-076",
    category: "Housing request",
    question: `How can I check the status of my request?`,
    answer: `Please provide your request reference, if available, together with your name, email address, destination, and submission date. The appropriate Oasis team can confirm the current status and next step. Please, send your inquiry to info@staywithoasis.com.`,
  },
  {
    id: "OAS-077",
    category: "Housing request",
    question: `I selected the option for Oasis managers to assess my needs. What happens next?`,
    answer: `Your requirements will be reviewed by an Oasis housing specialist. Oasis aims to acknowledge the request within 30 minutes during normal business hours and typically provides options within four hours in standard markets. Complex or remote-market requests may take up to 24 hours, and the team will provide updates if additional time is needed. Please, send your inquiry to info@staywithoasis.com.`,
  },
  {
    id: "OAS-078",
    category: "Housing request",
    question: `Can I change my request after submitting it?`,
    answer: `Yes. Contact Oasis as soon as possible with your request reference and the updated dates, location, budget, occupancy, or accommodation requirements. Changes may affect availability, pricing, and the time required to provide suitable options. Please, send your inquiry to info@staywithoasis.com.`,
  },
  {
    id: "OAS-079",
    category: "Guest journey",
    question: `I cannot find my welcome letter or arrival instructions.`,
    answer: `Please check your email, including your junk or spam folder. If you still cannot locate the welcome letter, email support@staywithoasis.com for a stay in the United States or gsintl@staywithoasis.com for a stay outside the United States. If you are due to check in now or are having trouble accessing the accommodation, call ${faqContacts.emergencyPhone} for immediate assistance.`,
  },
  {
    id: "OAS-080",
    category: "Guest support",
    question: `What are Oasis's normal business hours?`,
    answer: `Oasis's normal business hours are Monday to Friday, 8:00 AM to 6:00 PM EST. Non-urgent matters received outside these hours will be answered during the next business day. If you are experiencing an emergency, call ${faqContacts.emergencyPhone} for immediate assistance. Emergency support is available 24/7.`,
  },
];

export default faqData;
